import { useState, useEffect } from "react";
import common from "./common";

const AmlHashForm = (data) => {
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [validate, setValidate] = useState({});
  const [allow, setAllow] = useState(() => common.initAllow(data));
  const [isSubmit, setIsSubmit] = useState(false);
  const [reload, setReload] = useState(null);
  const [isField, setIsField] = useState("");

  // effect
  useEffect(() => {
    setFields(common.initFields(data));
    setErrors(common.initErrors(data));
    setValidate(common.initValidate(data));
    setAllow(common.initAllow(data));
  }, []);

  useEffect(() => {
    if (isSubmit && reload !== null) {
      validateForm();
    }
  }, [reload]);

  // set
  const setValue = (name, val) => {
    setFields((prev) => ({ ...prev, [name]: val }));
    setIsField(name);
    setReload(new Date());
  };

  const setMultiValue = (formFields) => {
    setFields((prev) => ({ ...prev, ...formFields }));
    setReload(new Date());
  };

  const setValidator = (err) => {
    setValidate(common.initValidate(err));
    if (isSubmit) {
      setReload(new Date());
    }
  };

  // handler
  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    let val = validatField(name, value);
    if (type == "checkbox" || type == "radio") {
      val = checked ? value : "";
    }
    setFields({ ...fields, [name]: val });
    setIsField(name);
    setReload(new Date());
  };

  const handleSubmit = () => {
    setIsSubmit(true);
    return validateForm();
  };

  const handleReset = (resetList = []) => {
    setIsSubmit(false);
    setErrors({});
    if (resetList.includes("values")) {
      setFields(common.initFields(data));
    }
    setReload(new Date());
  };

  // validate
  const validatField = (name, value) => {
    let isAllow = allow[name];
    if (isAllow === "number") {
      value = common.onlyNumbers(value);
    } else if (isAllow === "float") {
      value = common.onlyFloat(value);
    }
    return value;
  };

  const validateForm = () => {
    let isValid = true;
    let data = {};
    try {
      for (const [key, item] of Object.entries(validate)) {
        let field = fields[key];
        let req = item.req || field != "";

        if (item.req && field === "") {
          data[key] = item.req;
          isValid = false;
        } else if (item.notNull && field === null) {
          data[key] = item.notNull;
          isValid = false;
        } else if (item.email && req && !common.isEmail(field)) {
          data[key] = item.email;
          isValid = false;
        } else if (item.sameAs && req && field != item.sameAs.value) {
          data[key] = item.sameAs.message;
          isValid = false;
        } else if (
          item.sameAsField &&
          req &&
          field != fields[item.sameAsField.value]
        ) {
          data[key] = item.sameAsField.message;
          isValid = false;
        } else if (
          item.min &&
          req &&
          Number(item.min.value) > Number(field.length)
        ) {
          data[key] = item.min.message;
          isValid = false;
        } else if (item.max && req && item.max.value < Number(field.length)) {
          data[key] = item.max.message;
          isValid = false;
        } else if (
          item.et &&
          req &&
          (!common.isAllNumeric(field) ||
            Number(field) !== Number(item.et.value))
        ) {
          data[key] = item.et.message;
          isValid = false;
        } else if (
          item.net &&
          req &&
          (!common.isAllNumeric(field) ||
            Number(field) === Number(item.net.value))
        ) {
          data[key] = item.net.message;
          isValid = false;
        } else if (
          item.lt &&
          req &&
          (!common.isAllNumeric(field) ||
            Number(item.lt.value) <= Number(field))
        ) {
          data[key] = item.lt.message;
          isValid = false;
        } else if (
          item.lte &&
          req &&
          (!common.isAllNumeric(field) ||
            Number(field) > Number(item.lte.value))
        ) {
          data[key] = item.lte.message;
          isValid = false;
        } else if (
          item.gt &&
          req &&
          (!common.isAllNumeric(field) ||
            Number(item.gt.value) >= Number(field))
        ) {
          data[key] = item.gt.message;
          isValid = false;
        } else if (
          item.gte &&
          req &&
          (!common.isAllNumeric(field) ||
            Number(field) < Number(item.gte.value))
        ) {
          data[key] = item.gte.message;
          isValid = false;
        } else if (
          item.type &&
          item.type.value == "number" &&
          req &&
          !common.isAllNumeric(field)
        ) {
          data[key] = item.type.message;
          isValid = false;
        } else if (
          item.type &&
          item.type.value == "+-number" &&
          req &&
          !common.isNumeric(field)
        ) {
          data[key] = item.type.message;
          isValid = false;
        } else if (
          item.type &&
          item.type.value == "+float" &&
          req &&
          !common.isFloat(field)
        ) {
          data[key] = item.type.message;
          isValid = false;
        } else if (
          item.type &&
          item.type.value == "text" &&
          req &&
          field != null &&
          field.replace(/[a-zA-Z]/g, "") !== ""
        ) {
          data[key] = item.type.message;
          isValid = false;
        } else if (
          item.regExp &&
          req &&
          !common.isPattern(item.regExp.pattern, field)
        ) {
          data[key] = item.regExp.message;
          isValid = false;
        } else if (item.bool) {
          let boolVal = item.bool.value;
          if (
            (boolVal === "" && field === "") ||
            (boolVal === "true" && field !== true) ||
            (boolVal === "false" && field !== false)
          ) {
            data[key] = item.bool.message;
            isValid = false;
          }
        } else if (
          item.objValReq &&
          common.objectLevel(field, item.objValReq.obj) === ""
        ) {
          data[key] = item.objValReq.message;
          isValid = false;
        }
      }
      
      setErrors(data);
      return isValid;
    } catch (e) {
      alert("An error occurred in validate - " + e.message);
      return false;
    }
  };

  return {
    fields,
    errors,
    isField,
    setValue,
    setMultiValue,
    setValidator,
    handleChange,
    handleSubmit,
    handleReset,
  };
};

export default AmlHashForm;
